<div class="page-profile">
    <div class="container container-page-profile">
        <!-- <div class="loading-container" *ngIf="!profile; else divProfile"> -->
        <!-- <ng-lottie class="lottie" *ngIf="!profile" [options]="loadingLottie" containerClass="loading-box"></ng-lottie> -->
        <!-- </div> -->
        <!-- <ng-template #divProfile> -->
        <!-- Header Profile -->
        <div class="header-profile" [class.header-sitio]="profileMe?.site" [class.d-none]="!showMenu" *ngIf="!showUserMenu">
            <h1 style="font-size: 40px;">Mi cuenta</h1>
        </div>
         <div class="header-profile d-flex align-items-center title-purchases mobile" *ngIf="showUserMenu">
            <span (click)="toggleMenu()"><i class="icon-back fa-light fa-arrow-left"></i></span>
            <p class="m-0" (click)="toggleMenu()">Atrás</p>
        </div>

        <div class="title-profile mobile"  *ngIf="showUserMenu">
            <h1 style="font-size: 28px;">Mi perfil</h1>
        </div>

        <!-- Menu Profile -->
        <div class="menu-profile">

            <div class="section" [class.d-none]="!showMenu">
                <div class="menu-options">
                    <div *ngIf="!showUserMenu">
                        <div class="option top-option" routerLink="/profile/tickets" routerLinkActive="active" (click)="closeDropdown()">
                            <i class="icon-section fa-light fa-ticket"></i>
                            <div>
                                <p class="m-0 option-section">Mis entradas</p>
                            </div>
                            <i class="icon-open fa-light fa-chevron-right"></i>
                        </div>
                    </div>
                    <mat-divider *ngIf="!showUserMenu"></mat-divider>
                    <div *ngIf="!showUserMenu && isMobile">
                        <div class="option" (click)="toggleMenu()">
                            <i class="icon-section fa-light fa-user"></i>
                            <div>
                                <p class="m-0 option-section">Mi perfil</p>
                            </div>
                            <i class="icon-open fa-light fa-chevron-right" *ngIf="!dropdownOpen"></i>
                            <i class="icon-open fa-light fa-chevron-down" *ngIf="dropdownOpen"></i>
                        </div>
                    </div>
                    <div class="dropdown" *ngIf="!isMobile">
                        <div class="option" (click)="toggleDropdown()">
                            <i class="icon-section fa-light fa-user"></i>
                            <div>
                                <p class="m-0 option-section">Mi perfil</p>
                            </div>
                            <i class="icon-open fa-light fa-chevron-right" *ngIf="!dropdownOpen"></i>
                            <i class="icon-open fa-light fa-chevron-down" *ngIf="dropdownOpen"></i>
                        </div>
                    </div>
                    <mat-divider *ngIf="!showUserMenu"></mat-divider>
    
                    <div class="dropdown-content" [class.open]="dropdownOpen" *ngIf="!isMobile">
                        <div>
                            <div class="option" routerLink="/profile/edit" routerLinkActive="active">
                                <i class="icon-section fa-light fa-pen"></i>
                                <div>
                                    <p class="m-0 option-section">Mis datos</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div>
                            <div class="option" routerLink="/profile/pay_methods" routerLinkActive="active">
                                <i class="icon-section fa-light fa-credit-card"></i>
                                <div>
                                    <p class="m-0 option-section">Métodos de pago</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div>
                            <!-- <div class="option" routerLink="/profile/preferences" routerLinkActive="active"> -->
                            <div class="option disabled">
                                <i class="icon-section fa-light fa-head-side-heart"></i>
                                <div>
                                    <p class="m-0 option-section">Mis intereses</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div>
                            <!-- <div class="option" routerLink="/profile/subscriptions" routerLinkActive="active"> -->
                            <div class="option disabled" >
                                <i class="icon-section fa-light fa-envelopes-bulk"></i>
                                <div>
                                    <p class="m-0 option-section">Suscripciones</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        
                        <div>
                            <!-- <div class="option" routerLink="/profile/discounts" routerLinkActive="active"> -->
                            <div class="option disabled" >
                                <i class="icon-section fa-light fa-tags"></i>
                                <div>
                                    <p class="m-0 option-section">Descuentos</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
    
                        <mat-divider></mat-divider>
                    </div>
    
                    <div *ngIf="showUserMenu && isMobile">
                        <div>
                            <div class="option" routerLink="/profile/edit" routerLinkActive="active">
                                <i class="icon-section fa-light fa-pen"></i>
                                <div>
                                    <p class="m-0 option-section">Mis datos</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                          <div>
                            <div class="option" routerLink="/profile/pay_methods" routerLinkActive="active">
                                <i class="icon-section fa-light fa-credit-card"></i>
                                <div>
                                    <p class="m-0 option-section">Métodos de pago</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div>
                            <!-- <div class="option" routerLink="/profile/preferences" routerLinkActive="active"> -->
                            <div class="option disabled">
                                <i class="icon-section fa-light fa-head-side-heart"></i>
                                <div>
                                    <p class="m-0 option-section">Mis intereses</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div>
                            <!-- <div class="option" routerLink="/profile/subscriptions" routerLinkActive="active"> -->
                            <div class="option disabled">
                                <i class="icon-section fa-light fa-envelopes-bulk"></i>
                                <div>
                                    <p class="m-0 option-section">Suscripciones</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                      
                        <div>
                            <!-- <div class="option" routerLink="/profile/discounts" routerLinkActive="active"> -->
                            <div class="option disabled">
                                <i class="icon-section fa-light fa-tags"></i>
                                <div>
                                    <p class="m-0 option-section">Descuentos</p>
                                </div>
                                <i class="icon-open fa-light fa-chevron-right"></i>
                            </div>
                        </div>
    
                        <mat-divider></mat-divider>
                    </div>
    
                    <div *ngIf="!showUserMenu">
                        <div class="option" routerLink="/profile/notifications" routerLinkActive="active" (click)="closeDropdown()">
                            <i class="icon-section fa-light fa-bell"></i>
                            <div>
                                <p class="m-0 option-section">Notificaciones</p>
                            </div>
                            <i class="icon-open fa-light fa-chevron-right"></i>
                        </div>
                    </div>
                    <mat-divider *ngIf="!showUserMenu"></mat-divider>
                    <div *ngIf="!showUserMenu">
                        <div class="option" routerLink="/profile/faqs" routerLinkActive="active" (click)="closeDropdown()">
                            <i class="icon-section fa-light fa-circle-question"></i>
                            <div>
                                <p class="m-0 option-section">Ayuda/FAQ</p>
                            </div>
                            <i class="icon-open fa-light fa-chevron-right"></i>
                        </div>
                    </div>
                    <mat-divider *ngIf="!showUserMenu"></mat-divider>

                </div>
                <div class="logout" *ngIf="!showUserMenu">
                    <div (click)="logout()">
                        <i class="icon-section fa-light fa-arrow-right-from-bracket"></i>
                        <p class="m-0 option-section">Cerrar sesión</p>
                    </div>
                </div>
            </div>

            <div class="section-selected">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>